
import DateFilterService from '../services/date-filter-service';
import MatchesOddsModel from './model-match-odds';
import MatchesOutcomeModel from './model-match-outcome';

/**
 * Response model for home page widgets like todays matches, highlights and upcoming
 */
export default class MatchModel {
  /**
   * class constructor method
   * @param data
   * @param scorecastFirst
   */
  constructor(data) {
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = data.ht;
    /**
     * Home team Icon, we get this info from betradar
     * @type {string}
     */
    this.homeTeamIcon = data.hti ? `${APP_SETTINGS.path.teamImageUrl}${data.hti}` : '';
    /**
     * Guest team name
     * @type {string}
     */
    this.guestTeam = data.at;
    /**
     * Guest team Icon, we get this info from betradar
     * @type {string}
     */
    this.guestTeamIcon = data.ati ? `${APP_SETTINGS.path.teamImageUrl}${data.ati}` : '';
    /**
     * Sport ID
     * @type {number}
     */
    this.sportId = data.sid;
    /**
     * @type {string}
     */
    this.feedProvider = data.fpc;
    /**
     * Sport Name
     * @type {string}
     */
    this.sportName = data.sn;
    /**
     * Sport -> Category ID
     * @type {number}
     */
    this.categoryId = data.cid;
    /**
     * Sport -> Category
     * @type {string}
     */
    this.categoryName = data.cn;
    /**
     * Sport -> Category -> Tournament ID
     * @type {number}
     */
    this.tournamentId = data.tid;
    /**
     * Sport -> Category -> Tournament
     * @type {string}
     */
    this.tournamentName = data.tn;
    /**
     * Sport -> Category -> Tournament -> Match ID
     * @type {number}
     */
    this.matchId = data.mid;
    /**
     * Match ID from betradar
     * @type {number}
     */
    this.betRadarId = data.brid;
    /**
     * event code for the match
     * @type {number}
     */
    this.eventCode = data.ec;
    /**
     * the UTC date received from API
     * @type {string}
     */
    this.utcDate = data.d;

    this.cashOutVisibility = data.cs;
    /**
     * Match date (converted to local date)
     * @type {string}
     */
    this.date = DateFilterService.localDate(data.d, 'date', APP_SETTINGS.formatting.shortDateFormat, '');
    /**
     * Match time (converted to local time)
     * @type {string}
     */
    this.time = DateFilterService.localDate(data.d, 'time', '', APP_SETTINGS.formatting.shortTimeFormat);
    /**
     * Match number of odds
     * @type {number}
     */
    this.numberOfOdds = data.n || 0;
    /**
     * Match number of Markets
     * @type {number}
     */
    this.numberOfMarkets = data.nm || 0;
    /**
     * Match Odds + Odds->Outcomes
     * @type {array}
     */
    this.odds = this.mapOdds(data.o, data.ht, data.at);
    /**
     * Suspended match
     * @type {boolean}
     */
    this.suspended = data.su;
    /**
     * is tournament US
     * @type {boolean}
     */
    this.awayAtHome = data.tus;
    /**
     * Flag if  match has live stream
     * @type {boolean}
     */
    this.hasLiveStream = data.lc;
    /**
     * Match name
     * @type {string}
     */
    this.name = this.getName(data);
  }
  getName(data) {
    if (data.tus) {
      return `${this.guestTeam} @ ${this.homeTeam}`;
    }
    return `${this.homeTeam} vs ${this.guestTeam}`;
  }

  /**
   * Method for mapping inner objects from API with parent model
   * @param oddsList list of odds
   * @return mapped outcomes and odds in proper model
   */
  mapOdds(oddsList, homeTeam, guestTeam) {
    if (!oddsList) {
      return [];
    }
    let odds = [];
    oddsList.forEach((o) => {
      let odd = new MatchesOddsModel(o, homeTeam, guestTeam);
      if (o.m !== null) {
        odd.outcomes = o.m.map((m) => new MatchesOutcomeModel(m, homeTeam, guestTeam));
      }
      odds.push(odd);
    });
    return odds;
  }
}
